import CircularIndeterminate from "./common/icon/Loading";

const LoadingWidget = () => {
    return (<CircularIndeterminate />);
}

export default LoadingWidget;